import { eventService } from "../services/event-service";
import { EVENT_CTA_GET_STARTED_CLICK } from "shared";
import { pushState } from "./route-util";
import { ROUTES } from "../config";

/**
 * Goes to the get started page while tracking a click event.
 * Ref is the element referer (eg. navbar, hero button and so on)
 * @param ref
 */
export function getStarted(ref?: string) {
	eventService.trackEvent(EVENT_CTA_GET_STARTED_CLICK, { ref });
	pushState(ROUTES.getStarted);
}
